import React from "react";
import Fonts from "../../../../../utils/Fonts/Fonts";
import ColorPicker from "../../../ColorPicker";
import SelectSize from "../../../SelectSize";
import { withTranslation } from "react-i18next";
import Justify from "../../../../justify/justify";
import TitleAndSubTitle from "../../../ThemeEdit/titleAndSubtitle";
// import { FiEdit3 } from "react-icons/fi";
// import Avatar from "@material-ui/core/Avatar";

import { BsFillArrowDownLeftSquareFill } from "react-icons/bs";

function TitleStyle(props) {
  const handleColorsToChange = (e, name) => {
    const { r, g, b, a } = e.rgb;
    const value = `rgba(${r}, ${g}, ${b}, ${a})`;
    props.handleQuestionStyle({ target: { name, value } }, props.id, "title");
  };
  const {
    settings,
    style,
    handleQuestionStyle,
    fonts,
    id,
    useTitleCustomStyle,
    handleChangeQuestion,
    t,
  } = props;

  return (
    <>
      <div className="addSwitch override">
        <label className="switch">
          <input
            type="checkbox"
            name="withSubtitle"
            checked={useTitleCustomStyle ? true : false}
            onChange={(e) =>
              handleChangeQuestion(
                {
                  target: {
                    name: "useTitleCustomStyle",
                    type: "checkbox",
                    checked: useTitleCustomStyle ? false : true,
                  },
                },
                id
              )
            }
          />
          <span className="slider round"></span>
        </label>
        {t("rightBar-customize-override")}
      </div>
      {useTitleCustomStyle ? (
        <>
          <TitleAndSubTitle
            selectedTheme={"override-edit"}
            handleChange={handleQuestionStyle}
            context="title"
            props={props}
            handleColorsToChange={handleColorsToChange}
          />
        </>
      ) : (
        <>
          <div className="addSwitch-disabled"></div>
          <TitleAndSubTitle
            selectedTheme={"override-edit"}
            handleChange={{}}
            context="title"
            props={props}
            handleColorsToChange={{}}
          />
        </>
      )}
    </>
  );
}

export default withTranslation()(TitleStyle);
